import { createElement, useRef, useEffect } from 'react';

var styles = {"docked":"_11Ivv","main":"_3LgFW","container":"_3IMWP","snap":"_2PvlZ","nav":"_3qYJ8"};

var Docked;

(function (Docked) {
  Docked[Docked["None"] = 0] = "None";
  Docked[Docked["Left"] = 1] = "Left";
  Docked[Docked["Right"] = 2] = "Right";
  Docked[Docked["Both"] = 3] = "Both";
})(Docked || (Docked = {}));

var ShowIf;

(function (ShowIf) {
  ShowIf[ShowIf["Left"] = 1] = "Left";
  ShowIf[ShowIf["Right"] = 2] = "Right";
  ShowIf[ShowIf["Both"] = 3] = "Both";
  ShowIf[ShowIf["Always"] = 4] = "Always";
})(ShowIf || (ShowIf = {}));

var OverlappingPanels = function OverlappingPanels(_ref) {
  var width = _ref.width,
      height = _ref.height,
      docked = _ref.docked,
      leftPanel = _ref.leftPanel,
      children = _ref.children,
      rightPanel = _ref.rightPanel,
      bottomNav = _ref.bottomNav;

  if (docked) {
    return createElement("div", {
      className: styles.docked,
      style: {
        width: width,
        height: height
      }
    }, docked & 1 && leftPanel ? leftPanel.component : undefined, createElement("div", {
      className: styles.main
    }, children), docked & 2 && rightPanel ? rightPanel.component : undefined);
  }

  var scrollRef = useRef(null);
  var bottomNavRef = useRef(null);
  useEffect(function () {
    if (!bottomNav) return;
    if (!scrollRef.current) return;
    var el = scrollRef.current;

    function recalculate() {
      var bEl = bottomNavRef.current;
      if (!bEl) return;
      var showIf = typeof bottomNav.showIf === 'undefined' ? ShowIf.Both : bottomNav.showIf;

      if (showIf & ShowIf.Always) {
        bEl.style.top = '';
        return;
      }

      var lWidth = (leftPanel === null || leftPanel === void 0 ? void 0 : leftPanel.width) || 0;
      var rWidth = (rightPanel === null || rightPanel === void 0 ? void 0 : rightPanel.width) || 0;
      var hidden = bottomNav.height + 'px';

      if (el.scrollLeft < lWidth) {
        if (showIf & ShowIf.Left) {
          bEl.style.top = el.scrollLeft / lWidth * bottomNav.height + 'px';
          return;
        } else if (bEl.style.top === hidden) {
          return;
        }
      }

      if (el.scrollLeft > lWidth) {
        if (showIf & ShowIf.Right) {
          bEl.style.top = (el.scrollLeft - lWidth) / rWidth * -bottomNav.height + bottomNav.height + 'px';
          return;
        } else if (bEl.style.top === hidden) {
          return;
        }
      }

      bEl.style.top = hidden;
    }

    recalculate();
    el.addEventListener('scroll', recalculate);
    return function () {
      return el.removeEventListener('scroll', recalculate);
    };
  }, [scrollRef, leftPanel, rightPanel, bottomNav === null || bottomNav === void 0 ? void 0 : bottomNav.showIf]);
  var gridTemplateColumns = (leftPanel ? leftPanel.width + 'px' : '') + (" " + width + " ") + (rightPanel ? rightPanel.width + 'px' : '');
  return createElement("div", {
    className: styles.container
  }, createElement("div", {
    style: {
      width: width,
      height: height,
      gridTemplateColumns: gridTemplateColumns
    },
    className: styles.snap,
    ref: scrollRef
  }, leftPanel && createElement("div", {
    style: {
      height: height
    }
  }, leftPanel.component), children, rightPanel && createElement("div", {
    style: {
      height: height
    }
  }, rightPanel.component)), bottomNav && createElement("div", {
    className: styles.nav,
    style: {
      bottom: height
    }
  }, createElement("div", {
    style: {
      width: width,
      height: height
    },
    ref: bottomNavRef
  }, createElement("div", null, bottomNav.component))));
};

export { Docked, OverlappingPanels, ShowIf };
//# sourceMappingURL=index.modern.js.map
